import { get, del, post, put } from 'aws-amplify/api';
import { State } from '../models/state.model';
import { CreateState } from '../models/state.model';
import { UpdateState } from '../models/state.model';

export const getStates = async (): Promise<State[]> => {
  const response = await get({
    apiName: 'dealers',
    path: '/states',
  }).response;

  const json = (await response.body.json()) as State[];
  return json;
};

export const getState = async (stateId: string): Promise<State> => {
  const response = await get({
    apiName: 'dealers',
    path: `/states/${stateId}`,
  }).response;

  const json = (await response.body.json()) as State;
  return json;
};

export const createState = async (createState: CreateState): Promise<State> => {
  const response = await post({
    apiName: 'dealers',
    path: '/states',
    options: { body: createState },
  }).response;

  const json = (await response.body.json()) as State;
  return json;
};

export const updateState = async (stateId: string, updateState: UpdateState): Promise<State> => {
  const response = await put({
    apiName: 'dealers',
    path: `/states/${stateId}`,
    options: { body: updateState },
  }).response;

  const json = (await response.body.json()) as State;
  return json;
};

export const deleteState = async (stateId: string): Promise<void> => {
  await del({
    apiName: 'dealers',
    path: `/states/${stateId}`,
  }).response;
};
